import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VApp,
    { attrs: { "data-psych-doctor-information": "" } },
    [
      _c(VIcon, { on: { click: _setup.clickHandle } }, [
        _vm._v("\n    ui-icon-circle-info\n  "),
      ]),
      _vm._v(" "),
      _setup.isMobile
        ? _c(
            _setup.VBottomSheet,
            {
              model: {
                value: _setup.isActive,
                callback: function ($$v) {
                  _setup.isActive = $$v
                },
                expression: "isActive",
              },
            },
            [
              _c(VSheet, [
                _c(
                  "div",
                  { staticClass: "bottom-sheet-container px-4 py-6" },
                  [
                    _c("div", { staticClass: "text-h6 text--text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_setup.props.title) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _setup.props.subtitle
                      ? _c(
                          "div",
                          { staticClass: "text-body-1 text-secondary--text" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.props.subtitle) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "my-4 text-body-1 text--text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_setup.props.description) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      VBtn,
                      {
                        attrs: {
                          block: "",
                          color: "bg-primary--text",
                          elevation: "0",
                        },
                        on: { click: _setup.clickHandle },
                      },
                      [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("Понятно", { ns: _vm.$i18next.language })
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _c(
            _setup.CoreDialog,
            {
              attrs: {
                "data-qa": "psych-doctor-information-modal",
                size: "lg",
                divider: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "prependBtn",
                  fn: function ({ btnProps }) {
                    return [
                      _c(
                        VBtn,
                        _vm._b(
                          { on: { click: _setup.clickHandle } },
                          "v-btn",
                          btnProps,
                          false
                        ),
                        [
                          _c("span", {
                            staticClass: "ui-icon-close-not-a-circle",
                          }),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "title",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n      " + _vm._s(_setup.props.title) + "\n      "
                      ),
                      _setup.props.subtitle
                        ? _c(
                            "div",
                            { staticClass: "text-body-2 text-secondary--text" },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_setup.props.subtitle) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            "data-qa": "modal-actions-btn-close",
                            color: "primary",
                            elevation: "0",
                          },
                          on: { click: _setup.clickHandle },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("Понятно", { ns: _vm.$i18next.language })
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _setup.isActive,
                callback: function ($$v) {
                  _setup.isActive = $$v
                },
                expression: "isActive",
              },
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
                _vm._v(
                  "\n      " + _vm._s(_setup.props.description) + "\n    "
                ),
              ]),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }